import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { useSupplierDiversities } from '../../hooks';
import type { SupplierDiversity, SupplierDiversityFilters } from '../../models';

export interface SupplierDiversityFieldProps extends Omit<SelectProps<SupplierDiversity>, 'options'> {
  defaultFilters?: Partial<SupplierDiversityFilters & { searchParams: { ids: string[] } }>;
  label?: string;
  errorMessage?: SelectFieldProps<SupplierDiversity>['errorMessage'];
  isInvalid?: boolean;
}

export const SupplierDiversityField: React.FC<SupplierDiversityFieldProps> = ({
  defaultFilters,
  label,
  ...otherFieldProps
}) => {
  const { data, isLoading, updateFilters } = useSupplierDiversities(defaultFilters);

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Select"
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Select"
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
      isLoading={isLoading}
    />
  );
};
